
import api from "./api";

const masterService = {
  // Dashboard counts
  getDashboardCounts: () => api.get("/admin/dashboard-counts"),
    // Download user invoice (expects userId as param)
    // Download user invoice (expects userId and paymentId as params)
    downloadUserInvoice: (userId, paymentId) => {
      // Returns invoice info, including invoice_url
      return api.get(`/admin/user-subscription/invoices/${userId}?payment_id=${paymentId}`);
    },

    // Admin-initiated subscription assignment. Backend should accept { user_id,
    // plan_id, plan_type_id } and create the subscription on the user's behalf.
    assignUserSubscription: (payload) =>
      api.post(`/admin/user-subscription/assign`, payload),

    // Create a website user (u_user) from the admin side. Used by the "Add User"
    // form inside the Assign Subscription modal, so a subscription can be assigned
    // to someone who has never signed up.
    createWebsiteUser: (payload) => api.post(`/admin/user`, payload),

    // Options for the "Assign Subscription" modal — distinct users matching
    // ?search=, plus active plans and plan types in one round trip.
    getAssignSubscriptionOptions: (params = {}) => {
      const qs = new URLSearchParams();
      if (params.search) qs.append('search', params.search);
      if (params.perPage) qs.append('perPage', String(params.perPage));
      const tail = qs.toString();
      return api.get(`/admin/user-subscription/assign-options${tail ? '?' + tail : ''}`);
    },

  // User Subscription and Payment APIs for dashboard
 getUserSubscriptionList: (payload = {}) => {
  const {
    page = 1,
    pageSize = 20,
    user,
    email,
    mobile_code,
    mobile,
    planId,
    planTypeId,
    status,
    startDate,
    endDate,
    countryId,
    isActive,
    isDeleted,
    sortBy,
    sortOrder,
  } = payload;
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('pageSize', pageSize);
  if (user) params.append('user', user);
  if (email) params.append('email', email);
  if (mobile_code) params.append('mobile_code', mobile_code);
  if (mobile) params.append('mobile', mobile);
  if (sortBy) params.append('sortBy', sortBy);
  if (sortOrder) params.append('sortOrder', sortOrder);
  if (planId) params.append('planId', planId);
  if (planTypeId) params.append('planTypeId', planTypeId);
  if (status) params.append('status', status);
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);
  if (countryId) params.append('countryId', countryId);
  if (isActive !== undefined) params.append('isActive', isActive);
  if (isDeleted !== undefined) params.append('isDeleted', isDeleted);
  const url = `/admin/user-subscription?${params.toString()}`;
  return api.get(url);
},
 getPaymentList: (payload = {}) => {
  const {
    page = 1,
    pageSize = 20,
    user,
    userFirstName,
    user_firstname,
    status,
    minAmount,
    maxAmount,
    startDate,
    endDate,
    planId,
    planName,
    plan_name,
    planTypeId,
    planTypeName,
    plan_type_name,
    paymentSource,
    paymentTrigger,
    currency,
    email,
    mobile_code,
    mobile,
    sortBy,
    sortOrder,
  } = payload;
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('pageSize', pageSize);
  if (user) params.append('user', user);
  const username = user_firstname || userFirstName;
  if (username) params.append('user_firstname', username);
  if (email) params.append('email', email);
  if (mobile_code) params.append('mobile_code', mobile_code);
  if (mobile) params.append('mobile', mobile);
  if (sortBy) params.append('sortBy', sortBy);
  if (sortOrder) params.append('sortOrder', sortOrder);
  if (status) params.append('status', status);
  if (minAmount) params.append('minAmount', minAmount);
  if (maxAmount) params.append('maxAmount', maxAmount);
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);
  if (planId) params.append('planId', planId);
  const planNameFilter = plan_name || planName;
  if (planNameFilter) params.append('plan_name', planNameFilter);
  if (planTypeId) params.append('planTypeId', planTypeId);
  const planTypeNameFilter = plan_type_name || planTypeName;
  if (planTypeNameFilter) params.append('plan_type_name', planTypeNameFilter);
  if (paymentSource) params.append('paymentSource', paymentSource);
  if (paymentTrigger) params.append('paymentTrigger', paymentTrigger);
  if (currency) params.append('currency', currency);
  const url = `/admin/payment-record?${params.toString()}`;
  return api.get(url);
},
  // Video Show related
  getVideoShows: (payload) => {
    const {
      perPage = "10",
      currentPage = "1",
      searchText = "",
      status = "",
      isAll = false,
    } = payload;

    const params = new URLSearchParams();

    params.append("perPage", perPage);
    params.append("currentPage", currentPage);

    if (searchText) params.append("search", searchText);
    if (status && status !== "all") params.append("status", status);
    if (isAll) params.append("isAll", isAll);
    const queryString = params.toString();
    const url = `/admin/video_show${queryString ? `?${queryString}` : ""}`;

    return api.get(url);
  },
  // TV Show related
  getTvShows: (payload) => {
    const {
      perPage = "10",
      currentPage = "1",
      searchText = "",
      status = "",
      isAll = false,
    } = payload;

    const params = new URLSearchParams();

    params.append("perPage", perPage);
    params.append("currentPage", currentPage);

    if (searchText) params.append("search", searchText);
    if (status && status !== "all") params.append("status", status);
    if (isAll) params.append("isAll", isAll);
    const queryString = params.toString();
    const url = `/admin/tv_show${queryString ? `?${queryString}` : ""}`;

    return api.get(url);
  },

  // Image upload
  uploadImage: (formData) =>
    api.post("/admin/upload/image", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      timeout: 30000, 
    }),
  
  // Image remove
  removeImage: (payload) =>
    api.delete("/admin/upload/image", { data: payload }),

  // OnBoarding related
  getAllOnBoarding: (payload) =>
    api.get("/admin/onboarding", { params: payload }),

  getSingleOnBoarding: (mobId) => api.get(`/admin/onboarding/${mobId}`),

  saveOnBoarding: (payload) => api.post("/admin/onboarding", payload),

  saveOnBoardingOrderAndPlan: (payload) =>
    api.post("/admin/onboarding-order", payload),

  deleteOnBoarding: (mobId) => api.delete(`/admin/onboarding/${mobId}`),

  // Subscription Plans
  getSubscriptionPlans: () => api.get("/admin/sub_plan"),

  // Tags related
  getTags: () => api.get("/admin/tag"),

  // Seasons related
  getAllSeasonsOfTvShow: (payload) =>
    api.get("/admin/season", { params: payload }),

  // Country related
  getCountries: (payload) => {
    const { perPage, currentPage, searchText, status, mobVisible, hasFlag } = payload;
    let url = `/admin/country?perPage=${perPage}&currentPage=${currentPage}`;
    if (searchText) url += `&search=${searchText}`;
    if (status && status !== "all") url += `&status=${status}`;
    if (mobVisible === "true" || mobVisible === "false") url += `&mob_visible=${mobVisible}`;
    if (hasFlag === "true" || hasFlag === "false") url += `&has_flag=${hasFlag}`;
    return api.get(url);
  },

  getSingleCountry: (countryId) => api.get(`/admin/country/${countryId}`),

  getAllCountries: (payload = {}) => {
    const {
      perPage = "10",
      currentPage = "1",
      searchText = "",
      status = "",
      isAll = false,
    } = payload;
    const params = new URLSearchParams();
    params.append("perPage", perPage);
    params.append("currentPage", currentPage);
    if (searchText) params.append("search", searchText);
    if (status && status !== "all") params.append("status", status);
    if (isAll) params.append("isAll", isAll);
    const queryString = params.toString();
    const url = `/admin/country${queryString ? `?${queryString}` : ""}`;
    return api.get(url);
  },

  addCountry: (payload) => api.post("/admin/country/", payload),

  editCountry: (countryId, payload) =>
    api.put(`/admin/country/${countryId}`, payload),

  // Currency related
  getCurrencies: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    let url = `/admin/currency?perPage=${perPage}&currentPage=${currentPage}`;
    if (searchText) url += `&search=${searchText}`;
    return api.get(url);
  },

  getSingleCurrency: (currId) => api.get(`/admin/currency/${currId}`),

  addCurrency: (payload) => api.post("/admin/currency", payload),

  updateCurrency: (currId, payload) =>
    api.put(`/admin/currency/${currId}`, payload),

  getGenres: (payload = {}) => {
    const {
      perPage = "10",
      currentPage = "1",
      searchText = "",
      status = "",
      isAll = false,
      sortBy = "",
      sortOrder = "",
    } = payload;

    const params = new URLSearchParams();

    params.append("perPage", perPage);
    params.append("currentPage", currentPage);

    if (searchText) params.append("search", searchText);
    if (status && status !== "all") params.append("status", status);
    if (isAll) params.append("isAll", isAll);
    if (sortBy) params.append("sortBy", sortBy);
    if (sortOrder) params.append("sortOrder", sortOrder);
    const queryString = params.toString();
    const url = `/admin/video_genre${queryString ? `?${queryString}` : ""}`;

    return api.get(url);
  },

  getSingleGenre: (genreId) => api.get(`/admin/video_genre/${genreId}`),

  addGenre: (payload) => api.post("/admin/video_genre", payload),

  updateGenre: (genreId, payload) =>
    api.put(`/admin/video_genre/${genreId}`, payload),

    getMasterCategory: (payload = {}) => {
    const {
      perPage = "10",
      currentPage = "1",
      searchText = "",
      status = "",
      isAll = false,
    } = payload;

    const params = new URLSearchParams();

    params.append("perPage", perPage);
    params.append("currentPage", currentPage);

    if (searchText) params.append("search", searchText);
    if (status && status !== "all") params.append("status", status);
    if (isAll) params.append("isAll", isAll);
    const queryString = params.toString();
    const url = `/admin/master_category${queryString ? `?${queryString}` : ""}`;

    return api.get(url);
  },

    getSingleMasterCategory: (categoryId) => api.get(`/admin/master_category/${categoryId}`),

  AddMasterCategory: (payload) => api.post("/admin/master_category", payload),

  updateMasterCategory: (categoryId, payload) =>
    api.put(`/admin/master_category/${categoryId}`, payload),

  getSubGenres: (payload = {}) => {
    const {
      perPage = "10",
      currentPage = "1",
      searchText = "",
      status = "",
      isAll = false,
      genre_id = "",
    } = payload;

    const params = new URLSearchParams();

    params.append("perPage", perPage);
    params.append("currentPage", currentPage);

    if (searchText) params.append("search", searchText);
    if (status && status !== "all") params.append("status", status);
    if (isAll) params.append("isAll", isAll);
    if (genre_id) params.append("genre_id", genre_id);
    const queryString = params.toString();
    const url = `/admin/sub-genre${queryString ? `?${queryString}` : ""}`;

    return api.get(url);
  },

  getSingleSubGenre: (subGenreId) => api.get(`/admin/sub-genre/${subGenreId}`),

  addSubGenre: (payload) => api.post("/admin/sub-genre", payload),

  updateSubGenre: (subGenreId, payload) =>
    api.put(`/admin/sub-genre/${subGenreId}`, payload),

  getVideoLanguages: (payload = {}) => {
    const {
      perPage = "10",
      currentPage = "1",
      searchText = "",
      isAll = false,
      status = "",
    } = payload;

    const params = new URLSearchParams();

    params.append("perPage", perPage);
    params.append("currentPage", currentPage);
    if (searchText) params.append("search", searchText);
    if (isAll) params.append("isAll", isAll);
    if (status && status !== "all") params.append("status", status);
    const queryString = params.toString();
    const url = `/admin/languages/all${queryString ? `?${queryString}` : ""}`;

    return api.get(url);
  },

  getSingleLanguage: (langId) => api.get(`/admin/language/${langId}`),

  addLanguage: (payload) => api.post("/admin/language", payload),

  updateLanguage: (langId, payload) =>
    api.put(`/admin/language/${langId}`, payload),

  getTagList: (payload = {}) => {
    const {
      perPage = "10",
      currentPage = "1",
      searchText = "",
      isAll = false,
      status = "",
    } = payload;

    const params = new URLSearchParams();

    params.append("perPage", perPage);
    params.append("currentPage", currentPage);
    if (searchText) params.append("search", searchText);
    if (isAll) params.append("isAll", isAll);
    if (status && status !== "all") params.append("status", status);
    const queryString = params.toString();
    const url = `/admin/tag${queryString ? `?${queryString}` : ""}`;

    return api.get(url);
  },

  getSingleTag: (tagId) => api.get(`/admin/tag/${tagId}`),

  addTag: (payload) => api.post("/admin/tag", payload),

  updateTag: (tagId, payload) => api.put(`/admin/tag/${tagId}`, payload),

  // Content Type related
  getContentTypes: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    let url = `/admin/content_type?perPage=${perPage}&currentPage=${currentPage}`;
    if (searchText) url += `&search=${searchText}`;
    return api.get(url);
  },

  getSingleContentType: (ctId) => api.get(`/admin/content_type/${ctId}`),

  addContentType: (payload) => api.post("/admin/content_type", payload),

  updateContentType: (ctId, payload) =>
    api.put(`/admin/content_type/${ctId}`, payload),

  // Sales Channel related (already exists but need to update for pagination)
  getSalesChannels: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    let url = `/admin/sales_channel?perPage=${perPage}&currentPage=${currentPage}`;
    if (searchText) url += `&search=${encodeURIComponent(searchText)}`;
    return api.get(url);
  },

  getSingleSalesChannel: (scId) => api.get(`/admin/sales_channel/${scId}`),

  addSalesChannel: (payload) => api.post("/admin/sales_channel", payload),

  updateSalesChannel: (scId, payload) =>
    api.put(`/admin/sales_channel/${scId}`, payload),

  // FAQ related
  getFaqs: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    let url = `/admin/faq?perPage=${perPage}&currentPage=${currentPage}`;
    if (searchText) url += `&search=${searchText}`;
    return api.get(url);
  },

  getSingleFaq: (faqId) => api.get(`/admin/faq/${faqId}`),

  addFaq: (payload) => api.post("/admin/faq", payload),

  updateFaq: (faqId, payload) => api.put(`/admin/faq/${faqId}`, payload),

  // Privacy Policy related
  getPrivacyPolicies: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    let url = `/admin/privacy-policy?perPage=${perPage}&currentPage=${currentPage}`;
    if (searchText) url += `&search=${searchText}`;
    return api.get(url);
  },

  getSinglePrivacyPolicy: (ppId) => api.get(`/admin/privacy-policy/${ppId}`),

  addPrivacyPolicy: (payload) => api.post("/admin/privacy-policy", payload),

  updatePrivacyPolicy: (ppId, payload) =>
    api.put(`/admin/privacy-policy/${ppId}`, payload),

  // Terms & Conditions related
  getTermsConditions: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    let url = `/admin/terms-conditions?perPage=${perPage}&currentPage=${currentPage}`;
    if (searchText) url += `&search=${searchText}`;
    return api.get(url);
  },

  getSingleTermsConditions: (tcId) =>
    api.get(`/admin/terms-conditions/${tcId}`),

  addTermsConditions: (payload) => api.post("/admin/terms-conditions", payload),

  updateTermsConditions: (tcId, payload) =>
    api.put(`/admin/terms-conditions/${tcId}`, payload),

  // About Us related
  getAboutUs: () => api.get("/admin/about-us"),

  updateAboutUs: (payload) => api.put("/admin/about-us", payload),

  // Mobile App Store related
  getMobileAppStores: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    let url = `/admin/mobile-app-store?perPage=${perPage}&currentPage=${currentPage}`;
    if (searchText) url += `&search=${searchText}`;
    return api.get(url);
  },

  getSingleMobileAppStore: (storeId) =>
    api.get(`/admin/mobile-app-store/${storeId}`),

  addMobileAppStore: (payload) => api.post("/admin/mobile-app-store", payload),

  updateMobileAppStore: (storeId, payload) =>
    api.put(`/admin/mobile-app-store/${storeId}`, payload),

  // Mobile App Build Config related
  getMobileAppBuildConfigs: (payload) => {
    const { perPage, currentPage, searchText, scId } = payload;
    let url = `/admin/mobile-app-build-config?perPage=${perPage}&currentPage=${currentPage}`;
    if (searchText) url += `&search=${searchText}`;
    if (scId) url += `&sc_id=${scId}`;
    return api.get(url);
  },

  getSingleMobileAppBuildConfig: (buildConfigId) =>
    api.get(`/admin/mobile-app-build-config/${buildConfigId}`),

  addMobileAppBuildConfig: (payload) =>
    api.post("/admin/mobile-app-build-config", payload),

  updateMobileAppBuildConfig: (buildConfigId, payload) =>
    api.put(`/admin/mobile-app-build-config/${buildConfigId}`, payload),

  // Content Complaints related
  getContentComplaints: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    let url = `/admin/content-complaints?perPage=${perPage}&currentPage=${currentPage}`;
    if (searchText) url += `&search=${searchText}`;
    return api.get(url);
  },

  getSingleContentComplaint: (contentId) =>
    api.get(`/admin/content-complaints/${contentId}`),

  addContentComplaint: (payload) =>
    api.post("/admin/content-complaints", payload),

  updateContentComplaint: (contentId, payload) =>
    api.put(`/admin/content-complaints/${contentId}`, payload),

  uploadPdf: (formData) =>
    api.post("/admin/upload/pdf", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),

  // Payment Modes related
  getPaymentModes: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    let url = `/admin/payment_mode?perPage=${perPage}&currentPage=${currentPage}`;
    if (searchText) url += `&search=${searchText}`;
    return api.get(url);
  },

  getSinglePaymentMode: (pmId) => api.get(`/admin/payment_mode/${pmId}`),

  addPaymentMode: (payload) => api.post("/admin/payment_mode/", payload),

  updatePaymentMode: (pmId, payload) =>
    api.put(`/admin/payment_mode/${pmId}`, payload),

  // Payment Keys related
  getPaymentKeys: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    let url = `/admin/payment_key?perPage=${perPage}&currentPage=${currentPage}`;
    if (searchText) url += `&search=${searchText}`;
    return api.get(url);
  },

  getSinglePaymentKey: (paymentKeysId) =>
    api.get(`/admin/payment_key/${paymentKeysId}`),

  addPaymentKey: (payload) => api.post("/admin/payment_key/", payload),

  updatePaymentKey: (paymentKeysId, payload) =>
    api.put(`/admin/payment_key/${paymentKeysId}`, payload),

  // Device Info related
  getDeviceInfoList: (payload) => {
    const { perPage, currentPage, searchText, status } = payload || {};
    let url = `/admin/device-info?perPage=${perPage || 10}&currentPage=${
      currentPage || 1
    }`;
    if (searchText) url += `&search=${encodeURIComponent(searchText)}`;
    if (status && (status === "Y" || status === "N"))
      url += `&status=${status}`;
    return api.get(url);
  },

  getSingleDeviceInfo: (deviceInfoId) =>
    api.get(`/admin/device-info/${deviceInfoId}`),

  addDeviceInfo: (payload) => api.post("/admin/device-info", payload),

  updateDeviceInfo: (deviceInfoId, payload) =>
    api.put(`/admin/device-info/${deviceInfoId}`, payload),

  // Global Settings related
  getAllGlobalSettings: () => api.get("/admin/global_settings"),

  updateAllGlobalSettings: (payload, id) =>
    api.put(`/admin/global_settings/${id}`, payload),

  // Private Settings related
  getPrivateSettings: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    return api.get(
      `/admin/private_global_settings?perPage=${perPage}&currentPage=${currentPage}&search=${searchText}`
    );
  },

  getSinglePrivateSetting: (privateGlsId) =>
    api.get(`/admin/private_global_settings/${privateGlsId}`),

  addPrivateSetting: (payload) =>
    api.post("/admin/private_global_settings", payload),

  updatePrivateSetting: (privateGlsId, payload) =>
    api.put(`/admin/private_global_settings/${privateGlsId}`, payload),

  updateOnBoarding: (payload, mobId) =>
    api.put(`/admin/onboarding/${mobId}`, payload),

  createAvatar: (payload) => api.post("/admin/avatars", payload),

  updateAvatar: (payload, avatarId) =>
    api.put(`/admin/avatars/${avatarId}`, payload),

  getAvatarList: ({ perPage, currentPage, searchText, isAll }) => {
    const params = new URLSearchParams();
    if (perPage) params.append("perPage", perPage.toString());
    if (currentPage) params.append("currentPage", currentPage.toString());
    if (searchText) params.append("search", searchText.trim());
    if (isAll) params.append("isAll", String(isAll));
    const queryString = params.toString();
    return api.get(`/admin/avatars${queryString ? `?${queryString}` : ""}`);
  },

  getSingleAvatar: (avatarId) => api.get(`/admin/avatars/${avatarId}`),

  addFeature: (payload) => api.post("/admin/features", payload),

  updateFeature: (featureId, payload) =>
    api.put(`/admin/features/${featureId}`, payload),

  reorderFeatures: (payload) => api.post("/admin/features/reorder", payload),

  getSingleFeature: (featureId) => api.get(`/admin/features/${featureId}`),

  getFeatureList: ({ perPage, currentPage, searchText, status, isAll }) => {
    const params = new URLSearchParams();

    if (perPage) params.append("perPage", perPage.toString());
    if (currentPage) params.append("currentPage", currentPage.toString());
    if (searchText) params.append("search", searchText.trim());
    if (status && status !== "all") params.append("status", status);
    if (isAll) params.append("isAll", String(isAll));

    const queryString = params.toString();
    return api.get(`/admin/features${queryString ? `?${queryString}` : ""}`);
  },

  addPlanType: (payload) => api.post("/admin/plan-type", payload),

  updatePlanType: (planTypeId, payload) =>
    api.put(`/admin/plan-type/${planTypeId}`, payload),

  getSinglePlanType: (planTypeId) => api.get(`/admin/plan-type/${planTypeId}`),

  getPlanTypeList: ({ perPage, currentPage, searchText, status, isAll }) => {
    const params = new URLSearchParams();
    if (perPage) params.append("perPage", perPage.toString());
    if (currentPage) params.append("currentPage", currentPage.toString());
    if (searchText) params.append("search", searchText.trim());
    if (status && status !== "all") params.append("status", status);
    if (isAll) params.append("isAll", String(isAll));
    const queryString = params.toString();
    return api.get(`/admin/plan-type${queryString ? `?${queryString}` : ""}`);
  },

  addSubPlan: (payload) => api.post("/admin/plans", payload),

  updateSubPlan: (planId, payload) =>
    api.put(`/admin/plans/${planId}`, payload),

  getSingleSubPlan: (planId) => api.get(`/admin/plans/${planId}`),

  getSubPlanList: (payload) => {
    const { perPage, currentPage, searchText, status, isAll } = payload;
    let url = `/admin/plans?perPage=${perPage}&currentPage=${currentPage}`;
    if (searchText) url += `&search=${searchText}`;
    if (status && status !== "all") url += `&status=${status}`;
    if (isAll) url += `&isAll=${isAll}`;
    return api.get(url);
  },

  createTalent: (payload) => api.post("/admin/talent", payload),
  updateTalent: (talentId, payload) =>
    api.put(`/admin/talent/${talentId}`, payload),
  getTalent: (talentId) => api.get(`/admin/talent/${talentId}`),
  getTalentList: (payload) => {
    const { perPage, currentPage, searchText, status, isAll } = payload;
    let url = `/admin/talent?perPage=${perPage}&currentPage=${currentPage}`;
    if (searchText) url += `&search=${searchText}`;
    if (status && status !== "all") url += `&status=${status}`;
    if (isAll) url += `&isAll=${isAll}`;
    return api.get(url);
  },
};

export default masterService;
